import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { Company } from 'app/models/company.model';
import { GeneralZoneReport } from 'app/models/general-zone-report.model';
import { CompanyService } from 'app/services/company.service';
import { ExcelService } from 'app/services/excel.service';
import { GeneralReportService } from 'app/services/general-report.service';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexFill, ApexLegend, ApexPlotOptions, ApexStroke, ApexTheme, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    fill:ApexFill;
    tooltip:ApexTooltip;
    plotOptions: ApexPlotOptions;
    theme: ApexTheme;
    dataLabels: ApexDataLabels;
    yaxis: ApexYAxis;
    title: ApexTitleSubtitle;
    labels: string[];
    legend: ApexLegend;
    subtitle: ApexTitleSubtitle;
  };
  

@Component({
    selector: 'general-zone-report-list',
    templateUrl: './general-zone-report-list.component.html',
    styleUrls: ['./general-zone-report-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class GeneralZoneReportListComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    @ViewChild("chartCost") chartCost: ChartComponent;
    public chartOptionsCost: Partial<ChartOptions>;

    @ViewChild("chartProductivity") chartProductivity: ChartComponent;
    public chartOptionsProductivity: Partial<ChartOptions>;


    public widgetTotalSaving = 0;
    public widgetOptimizeCost = 0;
    public widgetBaseCost = 0;
    public widgetTotalContainer = 0;
    public widgetTotalOptimize = 0;

    public tableLoading = false;
    public selectByFilter = "year"
    public StartTime: Date;
    public EndTime: Date
    public companyId:number;
    public rootCompanyId:number;
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    
    private _companies : Array<Company> = [];
    public get companies() : Array<Company> {
        return this._companies;
    }
    public set companies(v : Array<Company>) {
        this._companies = v;
    }
    
    
    
    public _generalZoneReport: Array<GeneralZoneReport>
    
    private _dataSource: MatTableDataSource<GeneralZoneReport> = undefined;
    public get dataSource(): MatTableDataSource<GeneralZoneReport> {
        return this._dataSource;
    }

    private _displayedColumns = ['created_at','name','totalContainerCount', 'transactionCriteria','optimizeRouteContainerCount','baseRouteKm',"optimizeRouteKm","mileageSavings","timeSavings","productivity","baseCost","optimizeCost","mileageSavingsCost","timeSavingsCost","savingTotal"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _generalReportService: GeneralReportService,
        private _companyService: CompanyService,
        private route: ActivatedRoute,
        private router: Router,
        private _datePipe:DatePipe,
        private _excelService: ExcelService,
        private _spinner:NgxSpinnerService,
    ) {
        this.rootCompanyId = parseInt(localStorage.getItem("CompanyID"));
        this.chartOptionsCost = {
            series: [
                {
                  name: "Toplam Tasarruf",
                  data: [0,0]
                },
              ],
              chart: {
                type: "bar",
                height: 350
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
              },
              xaxis: {
                categories: []
              },
              yaxis: {
                title: {
                  text: "₺ (Tutar)"
                }
              },
              fill: {
                opacity: 1
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return "₺" + val + "Tl";
                  }
                }
              }
          };

        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: [0,0]
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: "straight"
              },
        
              title: {
                text: "Ulaşılan Max Doluluk",
                align: "left"
              },
              labels: [],
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: true
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }


    public async ngOnInit() {
        this.companyId = parseInt(localStorage.getItem("CompanyID"));
        await this.getCompanies();
        if(this.companyId==1){
            this.companyId = this.companies.find(x=>x.id !=1).id;
        }
        this.route.queryParams
        .subscribe(params => {
            if(params.start_date && params.end_date)
            {
                var startDate = new Date(params.start_date);
                var endDate = new Date(params.end_date);
                
                // Tarihlerin ay ve gün değerlerini yer değiştiriyoruz
                var formattedStartDate = startDate.toLocaleDateString('en-GB');
                var formattedEndDate = endDate.toLocaleDateString('en-GB');
                this.onTimeChangeClick("special", new Date(formattedStartDate),new Date(formattedEndDate))
            }
            else{
                this.onTimeChangeClick("month");
            }
        });

        this.companyId = 3;
        this.refresh()
    }

    public async getGeneralZoneReportList(){
        try {
            this._generalZoneReport = await this._generalReportService.getGeneralZoneReport(this.companyId,this.StartTime,this.EndTime);
        } catch (error) {
            console.warn(error);
        }
    }

    public onTableRowChange(element:GeneralZoneReport){
        this.router.navigate(
            ["apps/general-container-report-list"],
                { queryParams: 
                    {
                        "start_date":this._datePipe.transform(this.StartTime,"dd.MM.yyyy"),
                        "end_date":this._datePipe.transform(this.EndTime,"dd.MM.yyyy"),
                        "zone":element.name
                    }
                })
    }

    private async getCompanies(){
        try {
            this.companies = await this._companyService.getCompanies();
        } catch (error) {
            console.warn(error);
        }
    }

    // public async onReportClick() {
    //     const columns = ["No","Konteyner Adı", "Cihaz id", "Tarih","Boşaltılmadan Önce Tarih","Boşaltılmadan Sonra Tarih" ,"Boşaltılmadan Önce", "Boşaltıldıktan Sonra", "Adres"];
    //     let idx = 1;
    //     const dataset = this._generalContainerReport.map(p => {
    //         return {
    //             index: idx++,
    //             name: `${p.containerName}`,
    //             cihazId: `${p.deviceId}`,
    //             beforetarih: `${p.beforeDate}`,
    //             aftertarih: `${p.afterDate}`,
    //             dolulukOnce: `${p.beforeOccupancy}`,
    //             dolulukSonra: `${p.afterOccupancy}`,
    //             Address: `${p.address}`,

    //         }
    //     });
    //     this._excelService.exportAsExcelFile(
    //         columns,
    //         dataset,
    //         'Çöp Boşaltım Raporu',
    //         "",
    //         new Date(),
    //         {
    //             worksheetName: 'Çöp Boşaltım Raporu'
    //         }
    //     );
    // }

    public onTimeChangeClick(key: string, startTime?: Date, endTime?: Date) {
        debugger
        switch (key) {
            case "day":
                var end = new Date();
                var start = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0, 0);
                this.StartTime = start;
                this.EndTime = end
                break;
            // case "week":
            //     var end = new Date();
            //     var start = new Date(end.getFullYear(),end.getMonth(),end.getDate()-7,0,0);
            //     this.StartTime = start;
            //     this.EndTime = end
            //     break;
            case "year":
                var end = new Date();
                var start = new Date(end.getFullYear(),0,1,0,0);
                this.StartTime = start;
                this.EndTime = end
                this.selectByFilter = key;

                break;
            case "month":
                var end = new Date();
                var start = new Date(end.getFullYear(),end.getMonth(),1,0,-1);
                this.StartTime = start;
                this.EndTime = end
                break;

            default:
                this.StartTime = startTime;
                this.EndTime = endTime
                break;
        }
        this.refresh();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<GeneralZoneReport>(this._generalZoneReport);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    setWidgetData(){
        this.widgetOptimizeCost =0;
        this.widgetBaseCost =0;
        this.widgetTotalContainer =0;
        this.widgetTotalOptimize =0;
        this.widgetTotalSaving =0;

        this._generalZoneReport.forEach(x=>{
            this.widgetOptimizeCost += x.optimizeCost;
            this.widgetBaseCost += x.baseCost;
            this.widgetTotalContainer += x.totalContainerCount;
            this.widgetTotalOptimize += x.optimizeRouteContainerCount;
            this.widgetTotalSaving += x.savingTotal;
        })
    }

    public async setCostChart(){
        var dataBase = [];
        var dataOptimize = [];
        var dataMileageSavingCost = [];
        var dataTimeSavingCost = [];
        var dataSavingTotal = [];
        var dataBase = [];
        var label = [];
        this._generalZoneReport.forEach(x=>{
            dataBase.push(x.baseCost.toFixed(2));
            dataOptimize.push(x.optimizeCost.toFixed(2));
            dataMileageSavingCost.push(x.mileageSavingsCost.toFixed(2));
            dataTimeSavingCost.push(x.timeSavingsCost.toFixed(2));
            dataSavingTotal.push(x.savingTotal.toFixed(2));
            label.push(x.name?x.name:"");
        });
        this.chartOptionsCost = {
            series: [
                {
                  name: "Klasik Maliyet",
                  data: dataBase
                },
                {
                  name: "Gerçekleşen Maliyet",
                  data: dataOptimize
                },
                {
                  name: "Kilometreden Yakıt Tasarrufu",
                  data: dataMileageSavingCost
                },
                {
                  name: "Zamandan Yakıt Tasarrufu",
                  data: dataTimeSavingCost
                },
                {
                  name: "Toplam Tasarruf",
                  data: dataSavingTotal
                },
              ],
              chart: {
                type: "bar",
                height: 350
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
              },
              xaxis: {
                categories: label
              },
              yaxis: {
                title: {
                  text: "₺ (Tutar)"
                },
                min:0
              },
              fill: {
                opacity: 1
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return "₺" + val + "TL";
                  }
                }
              }
          };

    }

    public async setProductivityChart(){
        var data = [];
        var label = [];
        this._generalZoneReport.forEach(x=>{
            data.push(100-x.productivity);
            label.push(x.name?x.name:"");
        });
        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: data
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              
              stroke: {
                curve: "straight"
              },
              labels: label,
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: false,
                max:100,
                min:0
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }


    public async refresh(){
        await this.getGeneralZoneReportList();
        await this.updateTableDataSource();
        this.setWidgetData();
        this.setProductivityChart();
        this.setCostChart();
    }
}
